import { default as _91_91viewTitle_93_933m9IdVSrbPMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/[projectId]/index/index/[type]/[title]/[[viewTitle]].vue?macro=true";
import { default as authQDyrXlIZGuMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/[projectId]/index/index/auth.vue?macro=true";
import { default as indexrnhY7XqHinMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/[projectId]/index/index/index.vue?macro=true";
import { default as indexHR067kCzSuMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/[projectId]/index/index.vue?macro=true";
import { default as index7pyiZkuCObMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/[projectId]/index.vue?macro=true";
import { default as _91baseId_93tPDmb6XX1fMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/base/[baseId].vue?macro=true";
import { default as indexTld5TzYpGGMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/form/[viewId]/index/index.vue?macro=true";
import { default as surveyaP2QmUCLLBMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/form/[viewId]/index/survey.vue?macro=true";
import { default as indexWujd7jEPqTMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/form/[viewId]/index.vue?macro=true";
import { default as _91viewId_93RBf2fUufFcMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/form/[viewId].vue?macro=true";
import { default as indexZoj1p3TeUWMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/gallery/[viewId]/index.vue?macro=true";
import { default as indexy2XQKl6bMQMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/kanban/[viewId]/index.vue?macro=true";
import { default as _91viewId_933XW1BGdeU1Meta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/view/[viewId].vue?macro=true";
import { default as _91page_93yDXH5OCjecMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/account/index/[page].vue?macro=true";
import { default as _91_91nestedPage_93_93pELvJaW2DEMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/account/index/users/[[nestedPage]].vue?macro=true";
import { default as indexgezzQXpDqYMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/account/index.vue?macro=true";
import { default as _404tcGqBLUWY0Meta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/error/404.vue?macro=true";
import { default as forgot_45passwordJldgFziNUbMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/forgot-password.vue?macro=true";
import { default as apps6F6Bx14ZLuMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/index/apps.vue?macro=true";
import { default as _91projectId_937NqjazfwUYMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/index/index/[projectId].vue?macro=true";
import { default as create_45externalx1YzJAGgLyMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/index/index/create-external.vue?macro=true";
import { default as createtERUHAfJB6Meta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/index/index/create.vue?macro=true";
import { default as indexZbyEiNJ448Meta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/index/index/index.vue?macro=true";
import { default as userNmwPy7EZbsMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/index/index/user.vue?macro=true";
import { default as indexO9K9hXg6fAMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/index/index.vue?macro=true";
import { default as index6fCgmhgG6QMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/projects/index/index.vue?macro=true";
import { default as list59CZxOM43UMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/projects/index/list.vue?macro=true";
import { default as indexOywzeFociZMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/projects/index.vue?macro=true";
import { default as signinBXnGR1QP5fMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/signin.vue?macro=true";
import { default as _91_91token_93_93xHUDpl1WUMMeta } from "/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/signup/[[token]].vue?macro=true";
export default [
  {
    name: index7pyiZkuCObMeta?.name,
    path: "/:projectType()/:projectId()",
    meta: index7pyiZkuCObMeta || {},
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/[projectId]/index.vue").then(m => m.default || m),
    children: [
  {
    name: indexHR067kCzSuMeta?.name,
    path: "",
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/[projectId]/index/index.vue").then(m => m.default || m),
    children: [
  {
    name: "projectType-projectId-index-index-type-title-viewTitle",
    path: ":type()/:title()/:viewTitle?",
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/[projectId]/index/index/[type]/[title]/[[viewTitle]].vue").then(m => m.default || m)
  },
  {
    name: "projectType-projectId-index-index-auth",
    path: "auth",
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/[projectId]/index/index/auth.vue").then(m => m.default || m)
  },
  {
    name: "projectType-projectId-index-index",
    path: "",
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/[projectId]/index/index/index.vue").then(m => m.default || m)
  }
]
  }
]
  },
  {
    name: "projectType-base-baseId",
    path: "/:projectType()/base/:baseId()",
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/base/[baseId].vue").then(m => m.default || m)
  },
  {
    name: _91viewId_93RBf2fUufFcMeta?.name,
    path: "/:projectType()/form/:viewId()",
    meta: _91viewId_93RBf2fUufFcMeta || {},
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/form/[viewId].vue").then(m => m.default || m),
    children: [
  {
    name: indexWujd7jEPqTMeta?.name,
    path: "",
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/form/[viewId]/index.vue").then(m => m.default || m),
    children: [
  {
    name: "projectType-form-viewId-index",
    path: "",
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/form/[viewId]/index/index.vue").then(m => m.default || m)
  },
  {
    name: "projectType-form-viewId-index-survey",
    path: "survey",
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/form/[viewId]/index/survey.vue").then(m => m.default || m)
  }
]
  }
]
  },
  {
    name: "projectType-gallery-viewId",
    path: "/:projectType()/gallery/:viewId()",
    meta: indexZoj1p3TeUWMeta || {},
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/gallery/[viewId]/index.vue").then(m => m.default || m)
  },
  {
    name: "projectType-kanban-viewId",
    path: "/:projectType()/kanban/:viewId()",
    meta: indexy2XQKl6bMQMeta || {},
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/kanban/[viewId]/index.vue").then(m => m.default || m)
  },
  {
    name: "projectType-view-viewId",
    path: "/:projectType()/view/:viewId()",
    meta: _91viewId_933XW1BGdeU1Meta || {},
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/[projectType]/view/[viewId].vue").then(m => m.default || m)
  },
  {
    name: "account",
    path: "/account",
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/account/index.vue").then(m => m.default || m),
    children: [
  {
    name: "account-index-page",
    path: ":page()",
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/account/index/[page].vue").then(m => m.default || m)
  },
  {
    name: "account-index-users-nestedPage",
    path: "users/:nestedPage?",
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/account/index/users/[[nestedPage]].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "error-404",
    path: "/error/404",
    meta: _404tcGqBLUWY0Meta || {},
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/error/404.vue").then(m => m.default || m)
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordJldgFziNUbMeta || {},
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/forgot-password.vue").then(m => m.default || m)
  },
  {
    name: "index-apps",
    path: "//apps",
    meta: apps6F6Bx14ZLuMeta || {},
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/index/apps.vue").then(m => m.default || m)
  },
  {
    name: indexO9K9hXg6fAMeta?.name,
    path: "/",
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/index/index.vue").then(m => m.default || m),
    children: [
  {
    name: "index-index-projectId",
    path: ":projectId()",
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/index/index/[projectId].vue").then(m => m.default || m)
  },
  {
    name: "index-index-create-external",
    path: "create-external",
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/index/index/create-external.vue").then(m => m.default || m)
  },
  {
    name: "index-index-create",
    path: "create",
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/index/index/create.vue").then(m => m.default || m)
  },
  {
    name: "index-index",
    path: "",
    meta: indexZbyEiNJ448Meta || {},
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/index/index/index.vue").then(m => m.default || m)
  },
  {
    name: "index-index-user",
    path: "user",
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/index/index/user.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexOywzeFociZMeta?.name,
    path: "/projects",
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/projects/index.vue").then(m => m.default || m),
    children: [
  {
    name: "projects-index",
    path: "",
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/projects/index/index.vue").then(m => m.default || m)
  },
  {
    name: "projects-index-list",
    path: "list",
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/projects/index/list.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "signin",
    path: "/signin",
    meta: signinBXnGR1QP5fMeta || {},
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/signin.vue").then(m => m.default || m)
  },
  {
    name: "signup-token",
    path: "/signup/:token?",
    meta: _91_91token_93_93xHUDpl1WUMMeta || {},
    component: () => import("/home/runner/work/FINNoco/FINNoco/packages/nc-gui/pages/signup/[[token]].vue").then(m => m.default || m)
  }
]